export const DEFAULT_HEADER_OFFSET = 84;
const CURRENT_SECTION_TOLERANCE = 96;
const ROUTE_SCROLL_DELAY = 120;

function isElementInCurrentView(element, headerOffset) {
  const rect = element.getBoundingClientRect();
  const viewportHeight = window.innerHeight || document.documentElement.clientHeight;

  return rect.top < viewportHeight - 120 && rect.bottom > headerOffset + 60;
}

function clampScrollPosition(position) {
  const maxScroll = Math.max(
    0,
    document.documentElement.scrollHeight - window.innerHeight
  );

  return Math.min(Math.max(position, 0), maxScroll);
}

export function emitNavigationFeedback(message = 'Вы уже здесь', element) {
  window.dispatchEvent(
    new CustomEvent('navigation-feedback', {
      detail: { message },
    })
  );

  if (!element) return;

  element.classList.remove('is-navigation-target');
  void element.offsetWidth;
  element.classList.add('is-navigation-target');

  window.setTimeout(() => {
    element.classList.remove('is-navigation-target');
  }, 900);
}

export function scrollToSectionWithFeedback(
  id,
  {
    delay = 80,
    headerOffset = DEFAULT_HEADER_OFFSET,
    message = 'Вы уже здесь',
    retries = 4,
  } = {}
) {
  if (!id) return;

  window.setTimeout(() => {
    const element = document.getElementById(id);
    if (!element) {
      if (retries > 0) {
        scrollToSectionWithFeedback(id, {
          delay: 80,
          headerOffset,
          message,
          retries: retries - 1,
        });
      }
      return;
    }

    const rect = element.getBoundingClientRect();
    const offsetPosition = rect.top + window.pageYOffset - headerOffset;
    const reachableOffsetPosition = clampScrollPosition(offsetPosition);
    const currentPosition = window.pageYOffset;
    const isAtAnchor =
      Math.abs(currentPosition - reachableOffsetPosition) < CURRENT_SECTION_TOLERANCE;
    const isInsideCurrentSection = isElementInCurrentView(element, headerOffset);

    if (isAtAnchor || isInsideCurrentSection) {
      emitNavigationFeedback(message, element);
      return;
    }

    window.scrollTo({
      top: reachableOffsetPosition,
      behavior: 'smooth',
    });
  }, delay);
}

export function navigateWithFeedback({
  currentPath,
  navigate,
  section,
  target,
  delay = 80,
  headerOffset = DEFAULT_HEADER_OFFSET,
  message = 'Вы уже здесь',
}) {
  if (target && currentPath !== target) {
    document.scrollingElement.scrollTop = 0;
    navigate(target);

    if (!section) {
      window.setTimeout(() => {
        window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
      }, ROUTE_SCROLL_DELAY);
      return;
    }

    scrollToSectionWithFeedback(section, { delay, headerOffset, message });
    return;
  }

  if (section) {
    scrollToSectionWithFeedback(section, { delay, headerOffset, message });
    return;
  }

  if (window.pageYOffset < 16) {
    emitNavigationFeedback(message);
    return;
  }

  window.scrollTo({
    top: 0,
    behavior: 'smooth',
  });
}
